export const COIN_METRICS_COMMUNITY_BASE_URL = 'https://community-api.coinmetrics.io/v4';
export const COIN_METRICS_PRO_BASE_URL = 'https://api.coinmetrics.io/v4';
/** Websocket host for `/timeseries-stream/*` endpoints — same host/tier as `COIN_METRICS_PRO_BASE_URL`. */
export const COIN_METRICS_PRO_WS_BASE_URL = 'wss://api.coinmetrics.io/v4';
export const COIN_METRICS_TIER = {
  COMMUNITY: 'community',
  PRO: 'pro',
} as const;

/**
 * Safety ceiling for auto-pagination. Applied when an endpoint does not declare
 * an explicit maxPages. 50 pages × CM's default page_size of 100 = 5 000 records.
 */
export const COIN_METRICS_DEFAULT_MAX_PAGES = 50;

/** Key `CoinMetricsWebSocketClient` is registered under via `useRegisterSocketClient` — pass this as
 * `useSubscription(request, { client: CM_WEBSOCKET_CLIENT_KEY })` to route through it. */
export const CM_WEBSOCKET_CLIENT_KEY = 'cm';

/** `SubscriptionResponse.type` for every CoinMetrics asset-metric tick, regardless of which metric(s) it
 * carries — one constant for all of them so a future metric needs no new client changes. */
export const COIN_METRICS_ASSET_METRIC_TICK = 'coinMetricsAssetMetricTick';
